import "./Partners.css";
import { fetchPartnersLogos } from "src/network/fetchPartnersLogos";
import MoreButton from "../MoreButton";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "src/hooks/useIsMobile";

const Partners = () => {
  const partners = fetchPartnersLogos();
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();
  return (
    <section id="partners" className="partners-section">
      <div className="partners">
        <div className="partners-title">
          <h2>
            <span className="dotmedicod">dotmedico</span>
            <br />
            <span className="partners-text">partners</span>
          </h2>
          {!isMobile && (
          <MoreButton
            onClick={() => {
              navigate("/partners");
            }}
          />
        )}
        </div>
        <div className="partners-logos-container">
          <div
            className="partners-logos"
            style={{ animationPlayState: "running" }}
          >
            {[...partners, ...partners].map((partner, index) => (
              <div className="partner" key={index}>
                <div className="partner-logo">
                  <img
                    src={`${partner.source}`}
                    alt={`Partner ${index}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        {isMobile && (
          <MoreButton
            onClick={() => {
              navigate("/partners");
            }}
          />
        )}
      </div>
    </section>
  );
};

export default Partners;
